/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaContactViewProps } from './citta-contact';

export default (props: ICittaContactViewProps) => {
    const { ContactContainer, ContactForm, ErrorMessage, Name, EmailAddress, PhoneNumber, Country, City, ReasonForEnquiry, Message, Recaptcha, SubmitButton } = props;
    return (
        <Module {...ContactContainer}>
            <Node {...ContactForm}>
                {ErrorMessage}
                {Name}
                {EmailAddress}
                {PhoneNumber}
                {Country}
                {City}
                {ReasonForEnquiry}
                {Message}
                {Recaptcha}
                {SubmitButton}
            </Node>
        </Module>
    );
};